import { render, staticRenderFns } from "./AuditContentManage.vue?vue&type=template&id=38ee51f5&scoped=true"
import script from "./AuditContentManage.vue?vue&type=script&lang=js"
export * from "./AuditContentManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ee51f5",
  null
  
)

export default component.exports